module.exports = __webpack_public_path__ + "static/media/DSC_0119.30c429a0.jpg";